import React from 'react';
import { useLocation } from 'react-router-dom';
import { Bars3Icon, BellIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';

const Header = ({ onMenuClick }) => {
  const location = useLocation();
  const { college } = useAuth();

  // Get page title based on current route
  const getPageTitle = () => {
    const path = location.pathname;
    switch (path) {
      case '/dashboard':
        return 'Dashboard';
      case '/students':
        return 'Student Management';
      case '/faculty':
        return 'Faculty Management';
      case '/clubs':
        return 'Club Management';
      case '/campus-feed':
        return 'Campus Feed';
      default:
        return 'Unii College Admin';
    }
  };

  return (
    <header className="bg-white shadow border-b border-gray-200">
      <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
        <div className="flex items-center">
          {/* Mobile menu button */}
          <button
            type="button"
            className="lg:hidden -ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
            onClick={onMenuClick}
          >
            <Bars3Icon className="h-6 w-6" />
          </button>

          {/* Page title */}
          <div className="ml-4 lg:ml-0">
            <h1 className="text-2xl font-semibold text-gray-900">
              {getPageTitle()}
            </h1>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          {/* Notifications */}
          <button
            type="button"
            className="p-2 text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 rounded-md"
          >
            <BellIcon className="h-6 w-6" />
          </button>

          {/* College info */}
          <div className="hidden sm:flex sm:items-center">
            <div className="text-right">
              <p className="text-sm font-medium text-gray-900 truncate max-w-32">
                {college?.name}
              </p>
              <p className="text-xs text-gray-500">
                Admin Panel
              </p>
            </div>
            <div className="ml-3 flex-shrink-0">
              <div className="h-10 w-10 rounded-full bg-primary-100 flex items-center justify-center">
                <span className="text-primary-600 font-medium text-sm">
                  {college?.name?.charAt(0)?.toUpperCase() || 'C'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;